import { render, staticRenderFns } from "./usrapplylist.vue?vue&type=template&id=64a852db&scoped=true&"
import script from "./usrapplylist.vue?vue&type=script&lang=js&"
export * from "./usrapplylist.vue?vue&type=script&lang=js&"
import style0 from "./usrapplylist.vue?vue&type=style&index=0&id=64a852db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a852db",
  null
  
)

export default component.exports